export type View =
  | "home"
  | "messages"
  | "tasks"
  | "calendar"
  | "settings"
  | "linkedAccounts"
export const views: View[] = [
  "home",
  "messages",
  "tasks",
  "calendar",
  "settings",
  "linkedAccounts",
]

export interface GlobalSearchParams {
  view: View
  selectedMessage?: string
  slackOAuthError?: string
  slackOAuthSuccess?: string
  gmailOAuthError?: string
  gmailOAuthSuccess?: string
  calendarOAuthError?: string
  calendarOAuthSuccess?: string
}

export function parseSearchParams(
  searchParams: URLSearchParams
): GlobalSearchParams {
  const view = searchParams.get("view")
  const selectedMessage = searchParams.get("selectedMessage")

  return {
    selectedMessage: selectedMessage ? selectedMessage : undefined,
    view: views.includes(view as View) ? (view as View) : "home",
  }
}
